import React from "react"

interface Props {
  state, 
}

export class FooterComponent extends React.Component<Props> {
 
  constructor(props: Props) {
    super(props);

  }

  footer = (
    <footer>
      <nav className="asap-footer panel-title" style={{ marginTop: '2em' }} aria-label="footer">
        <div style={{ marginLeft: '15px', marginRight: '15px', padding: '20px 0' }}>

          <div className="col-md-12 footer">
            <a href="https://www.ontario.ca/page/terms-use" className="titlelink"
              title="{{'footer_terms_alt'|translate }}" tabIndex={-1}>
              <b>Terms of Use</b>
            </a> &nbsp;|&nbsp;
            <a href="#/faq-section" className="titlelink"
              title="{{'footer_contact_alt'|translate}}" tabIndex={-1}>       
              <b>Contact Us</b>
            </a>
            <a href="https://www.ontario.ca/page/terms-use" className="titlelink"
              title="{{'footer_contact_alt'|translate}}" tabIndex={-1}>       
              <b>Terms of Use</b>
            </a>
          </div>

          <div className="col-md-12 footer" style={{ paddingTop: '1em' }}>
            <a href="{{'footer_queensPrinter_link'|translate}}" className="titlelink"
              title="{{'footer_queensPrinter_alt'|translate }}" tabIndex={-1}       >
              <b>© King's Printer for Ontario, 2012-25</b>
            </a>
          </div>
        </div>
      </nav>
    </footer>
  );


  render() {
    return (
      this.footer
    )
  }
}
